export default "__VITE_ASSET__Dhqi97X7__";